<script setup>
import OnBoardingPage from '@/components/common/OnBoardingPage.vue'

/**
 * Page setup
 */
definePage({ meta: { layout: 'main' } })

const router = useRouter();

onMounted(() => {
  if (localStorage.getItem('nangman_use_mobile_web') === 'true') {
    router.replace('/main');
  }
});
</script>

<template>
  <OnBoardingPage />
</template>

<style lang="scss">
.header-wrap {
  background-color: transparent;
  .inner-base.pc {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.main-wrap {
  .content-holiday {
    top: auto !important;
  }
  .content-season {
    top: auto !important;
  }

  .data-item span {
    cursor: pointer;
  }
}

@media (max-width: 767px) {
  .footer-wrap {
    display: none;
  }
  .header-wrap {
    display: none;
  }
  body,
  #app {
    overflow-x: hidden;
    width: 100%;
    position: relative;
    -webkit-overflow-scrolling: touch;
  }

  // .main-layout,
  // .main-wrap {
  //   overflow: visible;
  //   height: auto;
  //   position: relative;
  // }

  // .mobile-guide-wrap {
  //   position: fixed;
  //   top: 0;
  //   left: 0;
  //   width: 100%;
  //   height: 100%;
  //   display: flex;
  //   justify-content: center;
  //   align-items: center;
  //   z-index: 9999;

  //   &.st-landing {
  //     position: relative;
  //     background: var(--Others-Light-Sky, #f2f5f8);
  //     overflow: visible;
  //     width: 100%;
  //     height: auto;
  //     -webkit-overflow-scrolling: touch;
  //   }
  // }
}

// .site-header {
//   position: fixed;
//   left: 0;
//   top: 0;
//   right: 0;
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   padding: 10px 20px;
//   border-bottom: 1px solid var(--Gray-300, #ebebeb);
//   background: var(--gray-100-white, #fff);
//   transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out, transform 0.3s ease-in-out;
//   visibility: visible;
//   opacity: 1;
//   z-index: 9;
//   transform: translateY(0);
//   height: 54px;

//   &.is-hidden {
//     opacity: 0;
//     visibility: hidden;
//     transform: translateY(-100%);
//   }
//   .btn-box {
//     display: flex;
//     height: 34px;
//     min-width: 40px;
//     max-width: 343px;
//     padding: 8px 10px;
//     justify-content: center;
//     align-items: center;
//     gap: 4px;
//     color: var(--gray-100-white, #fff);
//     text-align: center;
//     font-size: 14px;
//     font-style: normal;
//     font-weight: 700;
//     line-height: 18px; /* 128.571% */
//     border-radius: 6px;
//     background: var(--orange-300-main, #eb4c10);
//   }
// }

// .site-header h1 {
//   font-size: 20px;
//   margin: 0;
// }

// .site-main {
//   width: 100%;
//   height: auto;

//   section {
//     min-height: 100vh;
//     width: 100%;
//     box-sizing: border-box;
//     padding: 20px;
//     padding-top: 80px;
//     position: relative;
//   }
// }

// .btn-arrow-box {
//   text-align: center;
//   margin-top: 40px;
//   cursor: pointer; // 클릭 가능한 커서 스타일
//   display: inline-block; // 가운데 정렬을 위해 필요시 추가 (부모에 text-align: center 적용 시)

//   img {
//     max-width: 30px;
//     height: auto;
//     // 모바일 환경에서만 애니메이션 적용
//     @media (max-width: 767px) {
//       // 모바일 최대 너비
//       animation: bounce 1s infinite ease-in-out; // 바운스 애니메이션 적용
//     }
//     // PC 환경에서는 animation none 또는 여기서 정의 안 함
//   }
// }

// /* 화살표 애니메이션 키프레임 (투명도 변화 포함) */
// @keyframes bounce {
//   0%,
//   100% {
//     transform: translateY(0); // 시작과 끝은 제자리
//     opacity: 1; // 시작과 끝은 불투명
//   }
//   50% {
//     transform: translateY(-10px); // 중간 지점에서 위로 이동 (바운스 느낌)
//     opacity: 0.3; // 중간 지점에서 투명해짐
//   }
// }

// .landing-01 {
//   display: block;
//   width: 100%;
//   text-align: center;
//   background-color: #f2f5f8;
//   .logo-box {
//     padding: 0 0 50px;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     img {
//       max-width: 161px;
//     }
//   }
//   .txt-box {
//     margin-bottom: 28px;
//     .txt1 {
//       color: var(--Gray-800, #333);
//       text-align: center;
//       font-size: 22px;
//       font-style: normal;
//       font-weight: 400;
//       line-height: 32px; /* 145.455% */
//     }
//     .txt2 {
//       color: var(--Gray-800, #333);
//       font-size: 22px;
//       font-style: normal;
//       font-weight: 700;
//       line-height: 32px;
//     }
//   }
//   .btn-box {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     gap: 8px;
//     img {
//       max-width: 142px;
//       cursor: pointer;
//     }
//   }
//   .img-box {
//     width: 100%;
//     img {
//       max-width: 100%;
//     }
//   }
// }
// .landing-02,
// .landing-03 {
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   gap: 8px;
//   .txt-box {
//     margin-bottom: 28px;
//     display: flex;
//     flex-direction: column;
//     align-items: center;
//     gap: 8px;
//     .txt1 {
//       color: var(--orange-300-main, #eb4c10);
//       text-align: center;
//       font-size: 15px;
//       font-style: normal;
//       font-weight: 700;
//       line-height: 20px; /* 133.333% */
//     }
//     .txt2 {
//       color: var(--Gray-800, #333);
//       text-align: center;
//       font-size: 28px;
//       font-style: normal;
//       font-weight: 700;
//       line-height: 38px; /* 135.714% */
//     }
//     .txt3 {
//       color: var(--Gray-700, #575757);
//       text-align: center;
//       font-size: 15px;
//       font-style: normal;
//       font-weight: 500;
//       line-height: 25px; /* 166.667% */
//     }
//   }
// }

// .landing-02 {
//   padding-top: 64px;
//   width: 100%;
//   position: relative;
//   background: #fff;
//   min-height: 100vh;

//   .swiper-container {
//     width: 100%;
//     height: auto;
//     min-height: 90vh;
//     padding: 0;
//   }

//   .item {
//     width: 100%;
//     height: auto;
//     min-height: 90vh;
//     padding: 0 20px;
//     display: flex;
//     flex-direction: column;
//     gap: 20px;
//     position: relative;
//     user-select: none;
//     -webkit-user-select: none;
//     -webkit-touch-callout: none;
//     opacity: 0.5;
//     transform: scale(0.9);
//     transition: all 0.3s ease;
//     box-sizing: border-box;

//     &.swiper-slide-active {
//       opacity: 1;
//       transform: scale(1);
//     }

//     &.swiper-slide-prev,
//     &.swiper-slide-next {
//       opacity: 0.5;
//       transform: scale(0.9);
//     }

//     .txt-box {
//       display: flex;
//       flex-direction: column;
//       align-items: center;
//       gap: 8px;
//       z-index: 1;
//       width: 100%;
//       max-width: 320px;
//       margin: 0 auto;
//       padding: 0 10px;
//       box-sizing: border-box;
//     }

//     img {
//       width: 100%;
//       height: auto;
//       object-fit: contain;
//       max-width: 260px;
//       max-height: 400px;
//       margin: 0 auto;
//       flex: 1;
//     }
//   }
// }
// .landing-01 {
//   width: 100%;
//   .img-box {
//     img {
//       max-width: 307px;
//     }
//   }
// }
// .landing-03 {
//   .img-box {
//     width: 100%;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     img {
//       max-width: 260px;
//     }
//   }
// }

// .landing-02 {
//   .item {
//     img {
//       max-width: 260px;
//     }
//   }
// }

// .landing-04 {
//   .copyright {
//     padding-top: 160px;
//     color: var(--Gray-500, #949494);
//     text-align: center;
//     font-family: Pretendard;
//     font-size: 13px;
//     font-style: normal;
//     font-weight: 500;
//     line-height: 22px; /* 169.231% */
//     margin-bottom: 60px;
//   }
//   .img-box {
//     display: flex;
//     width: 100%;
//     justify-content: center;
//     align-items: center;
//     margin-bottom: 28px;
//     img {
//       max-width: 120px;
//       cursor: pointer;
//     }
//   }
//   .txt-box {
//     .txt1 {
//       color: var(--Gray-800, #333);
//       text-align: center;
//       font-size: 22px;
//       font-style: normal;
//       font-weight: 400;
//       line-height: 32px; /* 145.455% */
//       margin-bottom: 28px;
//     }
//     .txt2 {
//       color: var(--Gray-800, #333);
//       font-size: 22px;
//       font-style: normal;
//       font-weight: 700;
//       line-height: 32px;
//     }
//   }
//   .btn-box {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     gap: 8px;
//     margin-bottom: 80px;
//     img {
//       cursor: pointer;
//       max-width: 142px;
//     }
//   }
//   .txt-btm-box {
//     color: var(--Gray-700, #575757);
//     text-align: center;
//     font-size: 15px;
//     font-style: normal;
//     font-weight: 500;
//     line-height: 25px; /* 166.667% */
//     margin-bottom: 28px;
//   }
//   .sns-box {
//     display: flex;
//     align-items: center;
//     gap: 28px;
//     justify-content: center;
//     width: 100%;
//     img {
//       cursor: pointer;
//       max-width: 28px;
//     }
//   }
// }

// /* 섹션 공통 스타일 및 스크롤 애니메이션 초기 상태 */
// .site-main section {
//   // 스크롤 애니메이션 초기 상태 (모바일에서만 유효하도록 PC 미디어쿼리에서 재정의)
//   opacity: 0;
//   transform: translateY(50px); // 아래에서 위로 약간 이동하는 효과
//   transition: opacity 0.6s ease-out, transform 0.6s ease-out; // 애니메이션 효과
//   min-height: 100vh;
//   box-sizing: border-box;
//   padding: 20px;
//   padding-top: 80px;
// }

// .site-main section.landing-02,
// .site-main section.landing-03,
// .site-main section.landing-04,
// .site-main section.landing-05 {
//   background: #fff;
// }

// /* is-visible 클래스가 추가되면 최종 상태로 변화 */
// .site-main section.is-visible {
//   opacity: 1;
//   transform: translateY(0);
// }

// .mobile-guide-wrap.st-landing {
//   position: relative;
//   background: var(--Others-Light-Sky, #f2f5f8);
//   width: 100%;
//   height: auto;
//   min-height: 100vh;
// }

// 모바일에서의 스크롤 동작 개선
@media (max-width: 767px) {
  // body,
  // #app {
  //   overflow-x: hidden;
  //   width: 100%;
  // }

  // .mobile-guide-wrap.st-landing {
  //   overflow-x: hidden;
  //   overflow-y: auto;
  //   -webkit-overflow-scrolling: touch;
  // }

  // .site-main {
  //   overflow: visible;
  // }

  // .landing-02 {
  //   overflow: visible;

  //   .swiper-container {
  //     overflow: visible;
  //   }

  //   .item {
  //     padding: 0 15px;

  //     .txt-box {
  //       padding: 0 5px;
  //     }
  //   }
  // }
}

// 하단 가로스크롤 방지를 위한 스타일 추가
html,
body {
  overflow-x: hidden;
  width: 100%;
  position: relative;
}

// /* App Download Layer Styles */
// .app-download-container {
//   position: relative;
// }

// .app-download-layer {
//   position: absolute;
//   top: 100%;
//   right: 0;
//   margin-top: 8px;
//   background: white;
//   padding: 12px;
//   border-radius: 8px;
//   background: var(--gray-100-white, #fff);
//   box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
//   z-index: 1000;

//   .download-buttons {
//     display: flex;
//     flex-direction: column;
//     gap: 8px;
//     align-items: center;
//     width: 142px;

//     img {
//       width: 100%;
//       cursor: pointer;
//     }
//   }
// }
</style>
